module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp1_3.137a273e.png";